import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { BsArrowUpRight } from 'react-icons/bs'
import Rating from '@mui/material/Rating'
import { Helmet } from 'react-helmet-async'
import AI from '../Image/AI.jpg'
import ML from '../Image/ML.jpg'
import WD from '../Image/WD.webp'
import DS from '../Image/DS.jpeg'
import Android_App from '../Image/Android_App.jpg'
import Robotics from '../Image/Robotics.jpg'
import Cyber_Security from '../Image/Cyber_Security.jpg'
import Cloud_Computing from '../Image/Cloud_Computing.jpg'
import Human_Resource from '../Image/Human_Resource.jpg'
import Finance from '../Image/Finance.jpg'
import Business_Analytics from '../Image/Business_Analytics.jpg'
import AutoCAD from '../Image/AutoCAD.jpg'
import Digital_Marketing from '../Image/Digital_Marketing.jpg'
import VLSI from '../Image/VLSI.jpg'
import Internet_Of_Things from '../Image/Internet_Of_Things.jpg'
import Embedded_System from '../Image/Embedded_System.jpg'

function Our_program() {
  const courses = [
    {
      title: 'Artificial Intelligence',
      description:
        'Get started on an exciting new adventure in AI with our all-encompassing training program...',
      imageUrl: AI,
      rating: 4,
      link: '/Artificial-Intelligence',
      alt: 'Artificial-Intelligence',
    },
    {
      title: 'Machine Learning',
      description:
        'With our course, take a thorough exploration of the field of machine learning. Explore both supervised and...',
      imageUrl: ML,
      rating: 4,
      link: '/Machine-Learning',
      alt: 'Machine-Learning',
    },
    {
      title: 'Web Development',
      description:
        'With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM manipulation, jQuery, Node.js, and...',
      imageUrl: WD,
      rating: 4,
      link: '/Web-Development',
      alt: 'Web-Development',
    },
    {
      title: 'Data Science',
      description:
        'In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals...',
      imageUrl: DS,
      rating: 4,
      link: '/Data-Science',
      alt: 'Data-Science',
    },
    {
      title: 'Android App Development',
      description:
        'Embark on a dynamic journey into Android development with our comprehensive Training Internship...',
      imageUrl: Android_App,
      rating: 4,
      link: '/Android-App-Development',
      alt: 'Android-App-Development',
    },
    {
      title: 'Robotics',
      description:
        'With our extensive course, take a revolutionary step into the world of robotics. Explore the laws, types,...',
      imageUrl: Robotics,
      rating: 4,
      link: '/Robotics',
      alt: 'Robotics',
    },
    {
      title: 'Cyber Security',
      description:
        'With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical...',
      imageUrl: Cyber_Security,
      rating: 4,
      link: '/Cyber-Security',
      alt: 'Cyber-Security',
    },
    {
      title: 'Cloud Computing',
      description:
        'Discover the ever-changing realm of cloud computing with our all-inclusive course! Learn about Azure...',
      imageUrl: Cloud_Computing,
      rating: 4,
      link: '/Cloud-Computing',
      alt: 'Cloud-Computing',
    },
    {
      title: 'Human Resource',
      description:
        'In-depth study of Human Resource Management (HRM) will be provided in this course. Examine all aspects...',
      imageUrl: Human_Resource,
      rating: 4,
      link: '/Human-Resources',
      alt: 'Human-Resources',
    },
    {
      title: 'Finance',
      description:
        'With our extensive curriculum that covers Treasury duties, Corporate Finance, Portfolio Management,...',
      imageUrl: Finance,
      rating: 4,
      link: '/Finance',
      alt: 'Finance',
    },
    {
      title: 'Business Analytics',
      description:
        'With our in-depth training, you can enter the exciting field of Business Analytics. Gain familiarity...',
      imageUrl: Business_Analytics,
      rating: 4,
      link: '/Business-Analytics',
      alt: 'Business-Analytics',
    },
    {
      title: 'AutoCAD',
      description:
        'Learn AutoCAD from the ground up with our engaging course materials. Our training covers all the...',
      imageUrl: AutoCAD,
      rating: 4,
      link: '/Autocad',
      alt: 'AutoCAD',
    },
    {
      title: 'Digital Marketing',
      description:
        'Take a deep dive into the exciting world of marketing management and digital marketing. This...',
      imageUrl: Digital_Marketing,
      rating: 4,
      link: '/Digital-Marketing',
      alt: 'Digital-Marketing',
    },
    {
      title: 'VLSI',
      description:
        'VLSI technology has revolutionized the electronics industry by enabling the development of...',
      imageUrl: VLSI,
      rating: 4,
      link: '/Vlsi-Design',
      alt: 'VLSI',
    },
    {
      title: 'Internet Of Things',
      description:
        'IoT has the potential to revolutionize industries, enhance connectivity, and drive...',
      imageUrl: Internet_Of_Things,
      rating: 4,
      link: '/Internet-Of-Things',
      alt: 'Internet-Of-Things',
    },
    {
      title: 'Embedded System',
      description:
        'embedded systems play a crucial role in modern technology, enabling the functionality...',
      imageUrl: Embedded_System,
      rating: 4,
      link: '/Embedded-System',
      alt: 'Embedded-System',
    },
  ]

  const canonicalUrl = 'https://www.internselite.net/Traineeship-Program'
  return (
    <div>
      <Helmet>
        <title>
          Traineeship Program | InternsElite: Skill Development for the Future
        </title>
        <meta
          name="description"
          content="Enroll in InternsElite’s Traineeship Program to develop in-demand skills and advance your career. Our comprehensive courses include Machine Learning, AI, Web Development, Cyber Security, and more. Gain practical experience, earn certifications, and prepare for future job opportunities with our expert-led training."
        />
        <meta
          name="keywords"
          content="traineeship program, online training, certification course, professional courses, skill development, career advancement"
        />
        <meta
          property="og:title"
          content="Traineeship Program | InternsElite: Skill Development for the Future"
        />
        <meta
          property="og:description"
          content="Enroll in InternsElite’s Traineeship Program to develop in-demand skills and advance your career. Our comprehensive courses include Machine Learning, AI, Web Development, Cyber Security, and more. Gain practical experience, earn certifications, and prepare for future job opportunities with our expert-led training."
        />
        <meta
          property="og:url"
          content="https://internselite.net/Traineeship-Program"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Traineeship Program | InternsElite: Skill Development for the Future"
        />
        <meta
          name="twitter:description"
          content="Enroll in InternsElite’s Traineeship Program to develop in-demand skills and advance your career. Our comprehensive courses include Machine Learning, AI, Web Development, Cyber Security, and more. Gain practical experience, earn certifications, and prepare for future job opportunities with our expert-led training."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {/* --------------------------Mobile View-------------------------   */}
      <div className="Our_program_image d-sm-block d-md-none mt-5">
        <div className="container-fluid Our_background_color pt-4">
          <div className="text-center Our_program_Main_text py-5">
            <h1 className="display-4 text-white">Traineeship Program</h1>
            <h3 className="text-white fs-6 pt-2">
              Immerse in real-world challenges, gaining practical insights and
              honing your skills for a dynamic career journey.
            </h3>
          </div>
        </div>
      </div>
      <div className="container pt-5 d-sm-block d-md-none">
        <div className="text-center About_Discraption_text">
          <h1 className="display-4">What’s in store for YOU ?</h1>
        </div>
        <div className="container pb-5">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-12 px-4" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border pb-2 shadow Program_mobile_card">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                    />
                  </div>
                  <div className="px-3">
                    <div className="row">
                      <div className="col-10">
                        <h1 className="pt-2">{course.title}</h1>
                      </div>
                      <div className="col-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                      <h5 className="fw-normal pt-2">
                      4.5{' '}
                      <Rating
                        name="half-rating-read"
                        size="small"
                        defaultValue={5}
                        precision={4}
                        readOnly
                      />
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        </div>
      </div>

      {/* --------------------------Desktop View--------------------------- */}
      <div className="Our_program_image d-none d-md-block mt-5">
        <div className="container-fluid Our_background_color py-5">
          <div className="text-center pt-5 Our_program_Main_text mt-5">
            <h1 className="display-4 pt-5 text-white">Traineeship Program</h1>
            <h3 className="text-white fs-4 pb-5 pt-4 mb-5">
              Immerse in real-world challenges, gaining practical insights and
              honing your skills for a dynamic career journey.
            </h3>
          </div>
        </div>
      </div>
      {/* <div className="container pt-5 d-none d-xl-block">
        <div className="Container">
          <div className="text-center About_Discraption_text">
            <h1 className="display-4 pb-4">What’s in store for YOU ?</h1>
          </div>
        </div>
        <div className="container pb-5">
          <div className="row">
            {courses.map((course, index) => (
              <div className="col-md-3" key={index}>
                <Link className="Program_card_link" to={course.link}>
                  <div className="border shadow Program_card">
                    <div>
                      <img
                        className="p-2"
                        src={course.imageUrl}
                        alt={course.title}
                      />
                    </div>
                    <div className="px-4">
                      <h1 className="text-center pt-2">{course.title}</h1>
                      <p className="pt-1">{course.description}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* ------------------Tab View-------------------- */}
      <div className="container pt-5 d-none d-md-block d-xl-none">
        <div className="Container">
          <div className="text-center About_Discraption_text">
            <h1 className="display-4 pb-4">What’s in store for YOU ?</h1>
          </div>
        </div>
        <div className="container pb-5">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-md-3" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border shadow tab_Program_card pb-1">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                    />
                  </div>
                  <div className="px-3 tab_Program_card">
                    <div className="row">
                      <div className="col-md-10">
                        <h1 className="">{course.title}</h1>
                      </div>
                      <div className="col-md-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                      <h5 className="fw-normal pt-2">
                      4.5{' '}
                      <Rating
                        name="half-rating-read"
                        size="small"
                        defaultValue={5}
                        precision={4}
                        readOnly
                      />
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
  )
}

export default Our_program
